import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import HomePage from "@/pages/HomePage";
import FounderPage from "@/pages/FounderPage";
import WorkPage from "@/pages/WorkPage";

function App() {
  return (
    <BrowserRouter>
      <div className="site" data-testid="site-root">
        <a href="#main" className="skip-link">Skip to content</a>
        <Header />
        <main id="main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/founder" element={<FounderPage />} />
            <Route path="/work" element={<WorkPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
